import { defineTokens } from '@chakra-ui/react/styled-system';

export const colors = defineTokens.colors({
	'orange': {
		50: { value: '#FFF8F5FF' },
		100: { value: '#FEEBE1FF' },
		200: { value: '#FCCAB0FF' },
		300: { value: '#F9A980FF' },
		400: { value: '#F58851FF' },
		500: { value: '#F06824FF' },
		600: { value: '#D44F0CFF' },
		700: { value: '#A63C08FF' },
		800: { value: '#762A04FF' },
		900: { value: '#461802FF' }
	},
	'amber': {
		50: { value: '#FDF7F2FF' },
		100: { value: '#F4DCC8FF' },
		200: { value: '#EAC09EFF' },
		300: { value: '#E0A576FF' },
		400: { value: '#D48A4EFF' },
		500: { value: '#BF7131FF' },
		600: { value: '#945929FF' },
		700: { value: '#6B411FFF' },
		800: { value: '#442A15FF' },
		900: { value: '#331E0FFF' }
	},
	'yellow': {
		50: { value: '#FFFBF0FF' },
		100: { value: '#FEF2D2FF' },
		200: { value: '#FCE4A1FF' },
		300: { value: '#F9D571FF' },
		400: { value: '#F5C642FF' },
		500: { value: '#FFBC3DFF' },
		600: { value: '#C7950AFF' },
		700: { value: '#987106FF' },
		800: { value: '#684D03FF' },
		900: { value: '#372901FF' }
	},
	'blue': {
		50: { value: '#F0F8FFFF' },
		100: { value: '#DCEFFFFF' },
		200: { value: '#B3DDFEFF' },
		300: { value: '#8BCBFEFF' },
		400: { value: '#5DB6FDFF' },
		500: { value: '#0098DBFF' },
		600: { value: '#0462AFFF' },
		700: { value: '#01467EFF' },
		800: { value: '#002A4CFF' },
		900: { value: '#000E19FF' }
	},
	'gray': {
		50: { value: '#F2F5F7FF' },
		100: { value: '#E6EAEFFF' },
		200: { value: '#C7CFDBFF' },
		300: { value: '#AAB5C5FF' },
		400: { value: '#8E9BAFFF' },
		500: { value: '#718096FF' },
		600: { value: '#59687DFF' },
		700: { value: '#424F61FF' },
		800: { value: '#2C3644FF' },
		900: { value: '#181D26FF' }
	},
	'purple': {
		50: { value: '#FAF5FFFF' },
		100: { value: '#E9D8FDFF' },
		200: { value: '#D6BCFAFF' },
		300: { value: '#B794F4FF' },
		400: { value: '#9F7AEAFF' },
		500: { value: '#805AD5FF' },
		600: { value: '#6B46C1FF' },
		700: { value: '#553C9AFF' },
		800: { value: '#44337AFF' },
		900: { value: '#322659FF' }
	},
	'cyan': {
		50: { value: '#EDFDFDFF' },
		100: { value: '#C4F1F9FF' },
		200: { value: '#9DECF9FF' },
		300: { value: '#76E4F7FF' },
		400: { value: '#0BCCEAFF' },
		500: { value: '#00B5D8FF' },
		600: { value: '#00A3C4FF' },
		700: { value: '#0987A0FF' },
		800: { value: '#086F83FF' },
		900: { value: '#065666FF' }
	},
	'teal': {
		50: { value: '#F3FCFCFF' },
		100: { value: '#EBF9F9FF' },
		200: { value: '#DCF4F3FF' },
		300: { value: '#B6E7E5FF' },
		400: { value: '#92D9D7FF' },
		500: { value: '#6CC9C7FF' },
		600: { value: '#46BEBBFF' },
		700: { value: '#349D9AFF' },
		800: { value: '#267876FF' },
		900: { value: '#195251FF' }
	},
	'green': {
		50: { value: '#E1FFEE' },
		100: { value: '#C5F9DC' },
		200: { value: '#ADF2CB' },
		300: { value: '#88E8AC' },
		400: { value: '#54DA87' },
		500: { value: '#2BC669' },
		600: { value: '#00BA4C' },
		700: { value: '#008535' },
		800: { value: '#005221' },
		900: { value: '#003315' }
	},
	'pink': {
		50: { value: '#FFF5F7FF' },
		100: { value: '#FFE6EBFF' },
		200: { value: '#FDCED7FF' },
		300: { value: '#FB9DB0FF' },
		400: { value: '#F76E89FF' },
		500: { value: '#F24063FF' },
		600: { value: '#EC133DFF' },
		700: { value: '#BF0D30FF' },
		800: { value: '#910823FF' },
		900: { value: '#620417FF' }
	},
	'red': {
		50: { value: '#FFF5F7FF' },
		100: { value: '#FEE1E1FF' },
		200: { value: '#FEAEAEFF' },
		300: { value: '#FD7C7CFF' },
		400: { value: '#FB4B4BFF' },
		500: { value: '#F81B1BFF' },
		600: { value: '#D90808FF' },
		700: { value: '#A90404FF' },
		800: { value: '#790202FF' },
		900: { value: '#470101FF' }
	},
	'neutral': {
		50: { value: '#F6F7F8FF' },
		100: { value: '#EBEDEFFF' },
		200: { value: '#E0E3E6FF' },
		300: { value: '#C8CCD0FF' },
		400: { value: '#A7ACB4FF' },
		500: { value: '#8B929CFF' },
		600: { value: '#757D8AFF' },
		700: { value: '#5A616DFF' },
		800: { value: '#40444FFF' },
		900: { value: '#2C2E35FF' }
	},
},);